const MAX_TAIL_LINES = 80;
/** Avoid multi‑MB "lines" without newlines stalling JSON.stringify on preview_environment_status. */
const MAX_LINE_CHARS = 8192;
const MAX_PENDING_CHARS = 65536;

function truncateLine(s: string): string {
  return s.length > MAX_LINE_CHARS ? `${s.slice(0, MAX_LINE_CHARS)}…` : s;
}

export class StreamTail {
  private pending = '';
  private readonly lines: string[] = [];

  push(chunk: Buffer): void {
    this.pending += chunk.toString('utf8');
    if (this.pending.length > MAX_PENDING_CHARS) {
      this.pending = this.pending.slice(-MAX_PENDING_CHARS);
    }
    const parts = this.pending.split('\n');
    this.pending = parts.pop() ?? '';
    if (this.pending.length > MAX_PENDING_CHARS) {
      this.pending = this.pending.slice(-MAX_PENDING_CHARS);
    }
    for (const line of parts) {
      this.lines.push(truncateLine(line));
      if (this.lines.length > MAX_TAIL_LINES) this.lines.shift();
    }
  }

  /** Up to last 80 lines; any incomplete final line (no trailing newline) is included as the last entry. */
  getTail(): string[] {
    const out = [...this.lines];
    if (this.pending !== '') {
      out.push(truncateLine(this.pending));
    }
    if (out.length > MAX_TAIL_LINES) return out.slice(-MAX_TAIL_LINES);
    return out;
  }
}
